// Web Push subscription helper. Handles browser support detection,
// permission prompting, service worker registration, and server sync.
import { api, apiRaw } from "./api";

const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = atob(base64);
    const output = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
    return output;
};

export const pushSupported = () =>
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window;

export const pushPermission = () => {
    if (!pushSupported()) return "unsupported";
    return Notification.permission; // "default" | "granted" | "denied"
};

const getRegistration = async () => {
    if (!("serviceWorker" in navigator)) return null;
    // Register if not already
    let reg = await navigator.serviceWorker.getRegistration();
    if (!reg) {
        try {
            reg = await navigator.serviceWorker.register("/service-worker.js");
        } catch {
            return null;
        }
    }
    return reg;
};

export const enablePushForPhone = async (phone) => {
    if (!pushSupported()) throw new Error("Notifications not supported on this browser");
    const reg = await getRegistration();
    if (!reg) throw new Error("Service worker registration failed");
    const perm = await Notification.requestPermission();
    if (perm !== "granted") throw new Error("Permission denied");
    const { key } = (await apiRaw.get("/push/vapid-public-key")).data;
    if (!key) throw new Error("Server not configured");
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(key),
        });
    }
    const raw = sub.toJSON();
    await api.post(`/push/subscribe`, {
        phone,
        endpoint: raw.endpoint,
        keys: raw.keys,
    });
    return true;
};

export const disablePush = async (phone) => {
    if (!pushSupported()) return;
    const reg = await getRegistration();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const raw = sub.toJSON();
    try {
        await api.post(`/push/unsubscribe`, { phone, endpoint: raw.endpoint, keys: raw.keys });
    } catch {}
    await sub.unsubscribe();
};
